import { AgGridReact } from 'ag-grid-react';
import { AllocationReportTableParams } from '../useAllocationReport';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import './styles.pcss';

interface AllocationReportTableProps extends AllocationReportTableParams {
  reportDataError?: string;
}

export const AllocationReportTable: React.FC<AllocationReportTableProps> = ({
  gridOptions,
  onGridReady,
  rowData,
  reportDataError,
}) => {
  if (reportDataError) {
    return (
      <p className="body-base text-center py-32" data-test-id="allocation-report-no-metrics">
        {reportDataError}
      </p>
    );
  }

  return (
    <div className="ag-theme-material allocation-report-table">
      <AgGridReact gridOptions={gridOptions} onGridReady={onGridReady} rowData={rowData} rowHeight={36} />
    </div>
  );
};
